"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FlexRow = require("../../layout/flex/FlexRow");
var _Icon = require("../../media/icon/Icon");
var _flex = require("../../../components/layout/flex");
var _nestedCard = require("./nestedCard.tokens");
var _ContextMenu = _interopRequireDefault(require("../../../components/navigation/ContextMenu"));
var _StyledIcon = require("../../../components/media/icon/StyledIcon");
var _Text = _interopRequireDefault(require("../../../components/text/Text"));
var _Subheading = _interopRequireDefault(require("../../../components/text/Subheading"));
var _InnerButton = require("../../../components/controls/buttons/InnerButton");
var _jsxRuntime = require("react/jsx-runtime");
var NestedCardHeader = function NestedCardHeader(props) {
  var sectionName = props.sectionName,
    name = props.name,
    colorTheme = props.colorTheme,
    mainIcon = props.mainIcon,
    children = props.children,
    contextMenuOptions = props.contextMenuOptions,
    onExpand = props.onExpand,
    expanded = props.expanded,
    hasCollapsibleContent = props.hasCollapsibleContent;
  var chevronIcon = expanded ? "chevronUp" : "chevronDown";
  var showContextMenu = contextMenuOptions && contextMenuOptions.length;
  var iconColor = _nestedCard.nestedCardTokens.colorTheme[colorTheme].iconColor;
  var className = "nested-card-header-".concat(props.colorTheme);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Header, {
    justifyContent: "space-between",
    colorTheme: colorTheme,
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
      gap: 's',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        size: 'l',
        icon: mainIcon,
        customColor: iconColor
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: sectionName
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Subheading.default, {
        children: name
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
      justifyContent: "flex-end",
      gap: 'xl',
      children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_flex.FlexItem, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
          children: [showContextMenu ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextMenu.default, {
            contextMenuOptions: contextMenuOptions,
            iconColor: iconColor,
            changeOnHover: false
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(ContextMenuPlaceholder, {}), hasCollapsibleContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.WrapperButtonWithFocusRing, {
            "aria-label": 'Expand nested card',
            onPress: onExpand,
            focusRingColor: iconColor,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledIcon.StyledIcon, {
              icon: chevronIcon,
              size: 'l',
              customColor: iconColor,
              changeOnHover: false,
              "data-cy": 'expand-container'
            })
          })]
        })
      })]
    })]
  });
};
var Header = (0, _styledComponents.default)(_FlexRow.FlexRow).withConfig({
  displayName: "NestedCardHeader__Header",
  componentId: "sc-xr2c8k-0"
})(["padding:", ";&.nested-card-header-", " *:not(.context-menu *){color:", ";}svg{path{fill:", ";}}}"], _nestedCard.nestedCardTokens.padding.header, function (props) {
  return props.colorTheme;
}, function (props) {
  return _nestedCard.nestedCardTokens.colorTheme[props.colorTheme].textColor;
}, function (props) {
  return _nestedCard.nestedCardTokens.colorTheme[props.colorTheme].iconColor;
});
var ContextMenuPlaceholder = _styledComponents.default.div.withConfig({
  displayName: "NestedCardHeader__ContextMenuPlaceholder",
  componentId: "sc-xr2c8k-1"
})(["width:", ";"], _nestedCard.nestedCardTokens.spacing.contextMenuPlaceholder);
var _default = exports.default = NestedCardHeader;